export default __webpack_public_path__ + "favicons/fav-stage-32.png";